export default "__VITE_ASSET__BzSYv1LV__"